import React from 'react';
import { Text } from '@mantine/core';
import { SurveyItemRow } from '../../pages/price-surveys/types';
import { getPriceVariance } from '../../utility/priceVarianceUtils';
import { useDivisionalManagerSurveyProgressContextOptional } from '../../context/DivisionalManagerSurveyProgressContext';

interface PriceVarianceCellProps {
    row: SurveyItemRow;
}

export function PriceVarianceCell({ row }: PriceVarianceCellProps) {
    const context = useDivisionalManagerSurveyProgressContextOptional();
    const itemState = context?.getItemState(row.id);

    const { currentPrice, approvedForPriceChange } = row;

    const isApproved =
        itemState?.approvedForPriceChange ?? approvedForPriceChange;
    const proposedSellingPrice = itemState
        ? itemState.proposedSellingPrice
        : row.proposedSellingPrice;

    if (!isApproved || currentPrice == null || proposedSellingPrice == null) {
        return (
            <Text size="sm" c="dark.6">
                —
            </Text>
        );
    }

    const variance = getPriceVariance(currentPrice, proposedSellingPrice);
    if (variance === null) {
        return (
            <Text size="sm" c="dark.6">
                —
            </Text>
        );
    }

    const percent = (variance * 100).toFixed(1);
    return (
        <Text size="sm" c="dark.6">
            {percent}%
        </Text>
    );
}
